module.exports = __webpack_public_path__ + "img/fi-txt.25cd10b8.svg";